import React from "react";
import classes from "./DeleteBrandModal.module.css";

export default function DeleteBrandModal({
  count = 1,
  onCancel,
  onConfirm,
  loading,
}) {
  return (
    <div className={classes.backdrop} onClick={onCancel}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <header className={classes.header}>
          <h3>Delete Brand{count > 1 ? "s" : ""}</h3>
        </header>

        <div className={classes.body}>
          <p>
            Are you sure you want to delete {count} brand{count > 1 ? "s" : ""}?
            This action cannot be undone. Linked products must be reassigned
            before deleting.
          </p>
        </div>

        <footer className={classes.footer}>
          <button
            className={classes.secondaryBtn}
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className={classes.dangerBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </footer>
      </div>
    </div>
  );
}
